<template>
  <div>
    <div id="printTable">
      <div class="noprint printTableTitle">
        <h2>物资领用 送货/签收单</h2>
      </div>
      <List border size="small" style="margin-bottom: 20px">
        <ListItem>
          <Col span="3">
            <div class="printTableLeft">领用科室:</div>
          </Col>
          <Col span="21">{{ this.info.desk }}-{{ this.info.address }}</Col>
        </ListItem>
        <ListItem>
          <Col span="3">
            <div class="printTableLeft">设备信息:</div>
          </Col>
          <Col span="21">
            {{ this.info.facilityName == null ? "无" : this.info.facilityName }}
          </Col>
        </ListItem>
        <ListItem>
          <Col span="3" class="printTableLeft">
            <div class="printTableLeft">领用人:</div>
          </Col>
          <Col span="21">{{ this.info.receive }}</Col>
        </ListItem>
        <ListItem class="noprint" style="align-items: start">
          <Col span="3">
            <div class="printTableLeft">物资信息:</div>
          </Col>
          <Col span="21">
            <div class="printTableRight">
              <div
                class="printTableRightText"
                v-for="(item, index) in tabledata"
                :key="item.id"
              >
                {{ index + 1 }}.{{ item.brand }} {{ item.name }} / 型号：{{
                  item.model
                }}
                * {{ item.alertNum }}{{ item.unit }}
              </div>
            </div>
          </Col>
        </ListItem>
        <ListItem class="noprint">
          <Col span="3">
            <div class="printTableLeft">签收人:</div>
          </Col>
          <Col span="21"> </Col>
        </ListItem>
      </List>
      <div class="noprint" style="color: red">注：请确认物资信息后签字</div>
      <div class="noprints">
        <Table
          :columns="tableCols"
          :data="tabledata"
          :table="table"
          :border="table.border"
          :stripe="table.stripe"
          :header="table.header"
          :footer="table.footer"
          :columns-list="tableCols"
        >
        </Table>
      </div>
    </div>
    <div style="margin-top: 10px">
      <Button style="margin-left: 10px" type="primary" v-print="printObject">打印</Button>
    </div>
  </div>
</template>
<script>
import { IMAGE_HOST } from "@/../config";
import logo from "../../../assets/logo.png";
export default {
  name: "orderInfo",
  props: {
    kv: null,
    workId: {
      type: String,
      value: "",
    },
  },
  data() {
    return {
      printObject: {
        id: "printTable",
        popTitle: "物资领用 送货/签收单", // 打印配置页上方的标题
      },
      info: {},
      tabledata: [],
      table: {
        mname: "consumables",
        key: "id",
        url: {},
        output: false,
        border: true,
        rows: [],
        stripe: true,
        header: false,
        footer: false,
        order: "",
        router: {
          add: "",
          edit: "",
        },
      },
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 65,
          align: "center",
        },
        {
          title: "货物信息",
          width: 600,
          align: "center",
          render: (h, p) => {
            return h(
              "div",
              {
                style: {
                  height: "80px",
                  display: "flex",
                  justifyContent: "flex-start",
                },
              },
              [
                h("img", {
                  style: {
                    width: "60px",
                    height: "60px",
                    margin: "10px",
                  },
                  attrs: {
                    src:
                      p.row.consumableImgUrl == "" || p.row.consumableImgUrl == null
                        ? logo
                        : IMAGE_HOST + p.row.consumableImgUrl,
                  },
                }),
                h("div", [
                  h(
                    "p",
                    {
                      style: {
                        marginTop: "10px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      },
                      domProps: {
                        title: p.row.brand + p.row.name,
                      },
                    },
                    p.row.brand + p.row.name
                  ),

                  h(
                    "p",
                    {
                      style: {
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.model == null ? "none" : "block",
                      },
                      domProps: {
                        title: "型号:" + p.row.model,
                      },
                    },
                    "型  号: " + p.row.model
                  ),
                  h(
                    "p",
                    {
                      style: {
                        width: "400px",
                        textAlign: "left",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        display: p.row.remark == null ? "none" : "block",
                      },
                      domProps: {
                        title: "适用于: " + p.row.remark,
                      },
                    },
                    "适用于: " + p.row.remark
                  ),
                ]),
              ]
            );
          },
        },
        {
          title: "关联信息",
          width: 150,
          align: "left",
          key: "sysConsumableFacilityList",
          render: (h, params) => {
            const row = params.row.sysConsumableFacilityList;
            console.log(params.row);
            return (
              <div onClick={() => this.RelatesInfo(params.row)} style="cursor: pointer;">
                {row.length > 0 ? (
                  row.map((item) => (
                    <div>
                      {item.facilityNo}/{item.model}
                    </div>
                  ))
                ) : (
                  <div style="width: 10px; height: 20px; background-color: transparent; cursor: pointer;"></div>
                )}
              </div>
            );
          },
        },
        {
          title: "领用数",
          key: "alertNum",
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.unit;
            const num = row.alertNum;
            return (
              <span style={{ "font-size": "14px" }}>
                {num}/{text}
              </span>
            );
          },
        },
      ],
    };
  },
  created() {
    if (this.workId) {
      this.initData(this.workId);
    }
  },
  methods: {
    errorHandler() {
      return true;
    },
    initData(workId, page = 1) {
      // 加载详情工单数据
      let id = workId;
      $utils.api.load(`/admin/system/inventory/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.info = res.data;
          let list = res.data.sysConsumableFacilityList;
          let arr = res.data.sysConsumableReceiveDetails;
          for (let i = 0; i < arr.length; i++) {
            let item = arr[i];
            let obj = {};
            obj.consumableImgUrl = item.consumableImgUrl
              ? item.consumableImgUrl
              : "src\assets\logo.min.png";
            obj.brand = item.brand;
            obj.name = item.inventoryName;
            obj.model = item.model;
            obj.remark = item.remark;
            obj.unit = item.unit;
            obj.alertNum = item.alterNum;
            obj.sysConsumableFacilityList = list;
            this.tabledata.push(obj);
          }
        }
      });
    },
  },
};
</script>
<style lang="less">
#printTable .noprint {
  display: none;
}

.printTableTitle {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 20px;
}

.printTableLeft {
  font-weight: 600;
}

.printTableRight {
  width: 100%;

  .printTableRightText {
    word-wrap: break-word;
    word-break: break-all;
    white-space: pre-wrap;
    margin-top: 10px;
  }

  .printTableRightText:nth-child(1) {
    margin-top: 0;
  }
}

@media print {
  #printTable .noprint {
    display: flex !important;
  }

  .noprints {
    display: none;
  }
}
</style>
